module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.emailModalShown
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.emailResult.has) ? [_c('div', {
    staticClass: "notification",
    class: {
      'is-danger': !_vm.emailResult.success, 'is-success': _vm.emailResult.success
    }
  }, [_vm._v("\n            " + _vm._s(_vm.emailResult.success ? "L'envoi s'est effectué avec succès." : "Une erreur est survenue lors de l'envoi. Merci de rééssayer.") + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetEmailModal($event)
      }
    }
  }, [_vm._v("Fermer")])])] : [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail(s)")]), _vm._v(" "), _vm._l((_vm.emails), function(email, index) {
    return _c('div', {
      staticClass: "control is-grouped"
    }, [_c('p', {
      staticClass: "control is-expanded"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.emails[index]),
        expression: "emails[index]"
      }],
      staticClass: "input",
      attrs: {
        "type": "email",
        "placeholder": ("E-mail " + (index + 1))
      },
      domProps: {
        "value": (_vm.emails[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.emails, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('a', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteRecipient(index)
        }
      }
    }, [_vm._v("Supprimer")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRecipient($event)
      }
    }
  }, [_vm._v("Ajouter un destinataire")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.emailOngoing
    },
    attrs: {
      "disabled": _vm.emailOngoing
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendEmail($event)
      }
    }
  }, [_vm._v("Envoyer")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetEmailModal($event)
      }
    }
  }, [_vm._v("Annuler")])])])]], 2)]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.emailModalShown = false
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.step === _vm.STEPS.NAME) ? [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom du dossier")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.directoryName),
      expression: "directoryName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.directoryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.directoryName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createDirectory($event)
      }
    }
  }, [_vm._v("Créer le dossier")])])] : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === _vm.STEPS.UPLOAD),
      expression: "step === STEPS.UPLOAD"
    }]
  }, [_c('div', {
    ref: "dropzone",
    attrs: {
      "id": "dropzone"
    }
  }, [_c('h3', {
    staticClass: "dz-message"
  }, [_vm._v("Cliquez ou glissez-déposez un fichier")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Adresse du dossier"), _c('br'), _vm._v(" "), _c('code', [_c('a', {
    attrs: {
      "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId),
      "id": "folder-address",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.rootUrl) + "/dossier/" + _vm._s(_vm.directoryId))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._l((_vm.addedFiles), function(file) {
    return _c('li', [_vm._v("\n        " + _vm._s(file.file.name) + " (" + _vm._s(file.size) + ")\n        "), (file.done) ? [_c('span', {
      staticClass: "tag is-success"
    }, [_vm._v("Envoyé")]), _vm._v(" "), _c('a', {
      staticClass: "button is-small is-danger is-outlined",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteFile(file.fileName)
        }
      }
    }, [_c('span', [_vm._v("Supprimer")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_c('a', {
      attrs: {
        "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId + "/" + (file.fileName)),
        "id": ("file-" + _vm.directoryId + "-address"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.rootUrl) + "/dossier/" + _vm._s(_vm.directoryId) + "/" + _vm._s(file.fileName))])]), _vm._v(" "), _c('a', {
      staticClass: "button is-small copiable",
      attrs: {
        "data-clipboard-target": ("#file-" + _vm.directoryId + "-address")
      }
    }, [_c('span', [_vm._v("Copier")])])] : [_c('span', {
      staticClass: "tag is-dark"
    }, [_vm._v("Envoi en cours...")]), _c('br'), _vm._v(" "), _c('progress', {
      staticClass: "progress is-primary",
      attrs: {
        "max": "100"
      },
      domProps: {
        "value": file.progress
      }
    }, [_vm._v(_vm._s(file.progress) + "%")])]], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.emailModalShown = true
      }
    }
  }, [_vm._v("Envoyer par e-mail")])]), _vm._v(" "), _c('span')])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, [_c('strong', [_vm._v("Fonctionnement : ")]), _vm._v(" vous allez créer un "), _c('i', [_vm._v("dossier")]), _vm._v(". Un dossier est simplement un conteneur\n    dans lequel seront stockés vos fichiers.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-small copiable",
    attrs: {
      "data-clipboard-target": "#folder-address"
    }
  }, [_c('span', [_vm._v("Copier")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-376a8a6c!./~/vue-loader/lib/selector.js?type=template&index=0!./app/src/components/pages/Home.vue
// module id = 128
// module chunks = 0